/* global ym */

const METRIKA_ID = 87068309;

const EXCLUDED_PATHS = ["/bitrix/app", "/bitrix/install"];

const isExcluded = (path) => {
  return EXCLUDED_PATHS.some((p) => path.startsWith(p));
};

export const initMetrika = () => {
  if (isExcluded(window.location.pathname)) return;

  (function (m, e, t, r, i, k, a) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * new Date();
    k = e.createElement(t);
    a = e.getElementsByTagName(t)[0];
    k.async = 1;
    k.src = r;
    a.parentNode.insertBefore(k, a);
  })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

  ym(METRIKA_ID, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  });
};

export const hitMetrika = (path) => {
  if (isExcluded(path)) return;

  if (window.ym) {
    window.ym(METRIKA_ID, "hit", path);
  }
};
